var text6 = {
  size: 'p-6',
  weight: 'normal',
  tracking: 'normal',
  leading: 'densest' // 0.5rem // 8px
};
var text8 = {
  size: 'p-8',
  weight: 'normal',
  tracking: 'normal',
  leading: 'denser' // 0.625rem // 10px
};
var text10 = {
  size: 'p-10',
  weight: 'normal',
  tracking: 'normal',
  leading: 'snug' // 0.875rem // 14px
};
var text12 = {
  size: 'p-12',
  weight: 'normal',
  tracking: 'normal',
  leading: 'snug' // 0.875rem // 14px
};
var text14 = {
  size: 'p-14',
  weight: 'normal',
  tracking: 'normal',
  leading: 'none' // 1rem // 16px
};
var text16 = {
  size: 'p-16',
  weight: 'normal',
  tracking: 'normal',
  leading: 'compact' // 1.25rem // 20px
};
var text18 = {
  size: 'p-18',
  weight: 'normal',
  tracking: 'normal',
  leading: 'compact' // 1.25rem // 20px
};
var text20 = {
  size: 'p-20',
  weight: 'normal',
  tracking: 'normal',
  leading: 'normal' // 1.5rem // 24px
};
var text24 = {
  size: 'p-24',
  weight: 'normal',
  tracking: 'normal',
  leading: 'moderate' // 1.75rem // 28px
};
var textBold14 = {
  size: 'p-14',
  weight: 'bold',
  tracking: 'normal',
  leading: 'none' // 1rem // 16px
};
var textBold16 = {
  size: 'p-16',
  weight: 'bold',
  tracking: 'normal',
  leading: 'compact' // 1.25rem // 20px
};
var textBold18 = {
  size: 'p-18',
  weight: 'bold',
  tracking: 'normal',
  leading: 'compact' // 1.25rem // 20px
};
var textRelaxed12 = {
  size: 'p-12',
  weight: 'normal',
  tracking: 'normal',
  leading: 'none' // 1rem // 16px
};
var textRelaxed14 = {
  size: 'p-14',
  weight: 'normal',
  tracking: 'normal',
  leading: 'normal' // 1.5rem // 24px
};
var textRelaxed16 = {
  size: 'p-16',
  weight: 'normal',
  tracking: 'normal',
  leading: 'normal' // 1.5rem // 24px
};
var textRelaxed18 = {
  size: 'p-18',
  weight: 'normal',
  tracking: 'normal',
  leading: 'relaxed' // 2rem // 32px
};
var textRelaxed20 = {
  size: 'p-20',
  weight: 'normal',
  tracking: 'normal',
  leading: 'relaxed' // 2rem // 32px
};
var textRelaxed24 = {
  size: 'p-24',
  weight: 'normal',
  tracking: 'normal',
  leading: 'relaxed' // 2rem // 32px
};

/** NEWS  */
var newsText8 = {
  size: 'p-8',
  weight: 'normal',
  tracking: 'normal',
  leading: 'dense',
  // 0.75rem // 12px
  fontFamily: 'serif'
};
var newsText10 = {
  size: 'p-10',
  weight: 'normal',
  tracking: 'normal',
  leading: 'snug',
  // 0.875rem // 14px
  fontFamily: 'serif'
};
var newsText12 = {
  size: 'p-12',
  weight: 'normal',
  tracking: 'normal',
  leading: 'snug',
  // 0.875rem // 14px
  fontFamily: 'serif'
};
var newsText14 = {
  size: 'p-14',
  weight: 'normal',
  tracking: 'normal',
  leading: 'none',
  // 1rem // 16px
  fontFamily: 'serif'
};
var newsText16 = {
  size: 'p-16',
  weight: 'normal',
  tracking: 'normal',
  leading: 'compact',
  // 1.25rem // 20px
  fontFamily: 'serif'
};
var newsText18 = {
  size: 'p-18',
  weight: 'normal',
  tracking: 'normal',
  leading: 'compact',
  // 1.25rem // 20px
  fontFamily: 'serif'
};
var newsText20 = {
  size: 'p-20',
  weight: 'normal',
  tracking: 'normal',
  leading: 'dense',
  // 1.5rem // 24px
  fontFamily: 'serif'
};
var newsText24 = {
  size: 'p-24',
  weight: 'normal',
  tracking: 'normal',
  leading: 'dense',
  // 1.75rem // 28px
  fontFamily: 'serif'
};
var newsTextBold8 = {
  size: 'p-8',
  weight: 'bold',
  tracking: 'normal',
  leading: 'dense',
  // 0.75rem // 12px
  fontFamily: 'serif'
};
var newsTextBold10 = {
  size: 'p-10',
  weight: 'bold',
  tracking: 'normal',
  leading: 'snug',
  // 0.875rem // 14px
  fontFamily: 'serif'
};
var newsTextBold12 = {
  size: 'p-12',
  weight: 'bold',
  tracking: 'normal',
  leading: 'snug',
  // 0.875rem // 14px
  fontFamily: 'serif'
};
var newsTextBold14 = {
  size: 'p-14',
  tracking: 'normal',
  leading: 'none',
  // 1rem // 16px
  weight: 'bold',
  fontFamily: 'serif'
};
var newsTextBold16 = {
  size: 'p-16',
  tracking: 'normal',
  leading: 'compact',
  // 1.25rem // 20px
  weight: 'bold',
  fontFamily: 'serif'
};
var newsTextRelaxed12 = {
  size: 'p-12',
  tracking: 'normal',
  leading: 'none',
  // 1rem // 16px
  fontFamily: 'serif'
};
var newsTextRelaxed14 = {
  size: 'p-14',
  tracking: 'normal',
  leading: 'normal',
  // 1.5rem // 24px
  fontFamily: 'serif'
};
var newsTextRelaxed16 = {
  size: 'p-16',
  tracking: 'normal',
  leading: 'normal',
  // 1.5rem // 24px
  fontFamily: 'serif'
};
var newsTextRelaxed18 = {
  size: 'p-18',
  tracking: 'normal',
  leading: 'relaxed',
  // 2rem // 32px
  fontFamily: 'serif'
};
var newsTextRelaxed20 = {
  size: 'p-20',
  tracking: 'normal',
  leading: 'relaxed',
  // 2rem // 32px
  fontFamily: 'serif'
};
var newsTextRelaxed24 = {
  size: 'p-24',
  tracking: 'normal',
  leading: 'relaxed',
  // 2rem // 32px
  fontFamily: 'serif'
};
var textVariants = {
  'text-6': text6,
  'text-8': text8,
  'text-10': text10,
  'text-12': text12,
  'text-14': text14,
  'text-16': text16,
  'text-18': text18,
  'text-20': text20,
  'text-24': text24,
  'text-bold-14': textBold14,
  'text-bold-16': textBold16,
  'text-bold-18': textBold18,
  'text-relaxed-12': textRelaxed12,
  'text-relaxed-14': textRelaxed14,
  'text-relaxed-16': textRelaxed16,
  'text-relaxed-18': textRelaxed18,
  'text-relaxed-20': textRelaxed20,
  'text-relaxed-24': textRelaxed24,
  'news-text-8': newsText8,
  'news-text-10': newsText10,
  'news-text-12': newsText12,
  'news-text-14': newsText14,
  'news-text-16': newsText16,
  'news-text-18': newsText18,
  'news-text-20': newsText20,
  'news-text-24': newsText24,
  'news-text-bold-8': newsTextBold8,
  'news-text-bold-10': newsTextBold10,
  'news-text-bold-12': newsTextBold12,
  'news-text-bold-14': newsTextBold14,
  'news-text-bold-16': newsTextBold16,
  'news-text-relaxed-12': newsTextRelaxed12,
  'news-text-relaxed-14': newsTextRelaxed14,
  'news-text-relaxed-16': newsTextRelaxed16,
  'news-text-relaxed-18': newsTextRelaxed18,
  'news-text-relaxed-20': newsTextRelaxed20,
  'news-text-relaxed-24': newsTextRelaxed24
};

export { textVariants };
//# sourceMappingURL=text.variants.esm.js.map
